<template>
  <b-card  style="position: relative;" class="mb-0">
    <b-row class="text-center">
     <b-col>Monitor Credit Scoring tasks</b-col>
    </b-row>

     <div style="overflow-x: auto;">
         <b-table 
         show-empty
          hover
          small
          head-variant="dark" 
         :items="notif_data">
         
         </b-table>
    </div>
  </b-card>
  
</template>

<script>
  import axios from 'axios';
  import {fullURL} from '../utils';

  export default {
    name: 'NotificationPage',

    data() {
      const F = this.$store.state.files.fileList;

      return {
        F: F,
        notif_data:null
      };
    },

    created(){
        axios.get(
      fullURL('/notifications')
    ).then(({data}) =>{

        this.notif_data = data;
    }).catch(e => {
		console.log(e);
					
      });
    },

    computed: {
      
    },

    watch: {
      
    },

    methods: {
      
    }
  };
</script>
